import React from 'react';
import NewIntegrations from './NewIntegrations';

const Integrations = (props) => {
  const { contact, newIntegrationSyncs } = props;
  //TODO old integration service goes into chat DB to get the integrations ID, won't be needing that once all types of the integrations are implemented
  const integrationKeys = Object.keys(contact.external_ids);
  const contactsIntegrations = contact.external_ids;
  return (
    <div className="contact-integrations-box">
      {integrationKeys.map((integration, i) => {
        return (
          <div className="integration" key={i}>
            <span className="integration_name col-4 p-0">{integration}:</span>{' '}
            <div className="integration_value">
              Synced with Contact ID {contactsIntegrations[integration]}
            </div>
          </div>
        );
      })}
      <NewIntegrations
        syncs={newIntegrationSyncs?.syncs || []}
        errors={newIntegrationSyncs?.errors || []}
      ></NewIntegrations>
    </div>
  );
};

export default Integrations;
